import React from 'react';
import { useOnboardingForm } from '../hooks/useOnboardingForm';
import Stepper from '../components/onboarding/Stepper';
import StepWelcome from '../components/onboarding/StepWelcome';
import StepPersonalInfo from '../components/onboarding/StepPersonalInfo';
import StepContactInfo from '../components/onboarding/StepContactInfo';
import StepPhoto from '../components/onboarding/StepPhoto';
import StepDocuments from '../components/onboarding/StepDocuments';
import StepConfirmation from '../components/onboarding/StepConfirmation';
import './DriverOnboarding.css';

const DriverOnboarding = () => {
  const {
    currentStep,
    formData,
    isSubmitting,
    error,
    setIsSubmitting,
    setError,
    updateFormData,
    updateDocuments,
    setDocumentValidated,
    nextStep,
    prevStep,
    setApplicationId,
  } = useOnboardingForm();

  const handleSubmitSuccess = (applicationId) => {
    setApplicationId(applicationId);
    // Limpiar localStorage después de éxito
    localStorage.removeItem('jama_driver_onboarding');
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <StepWelcome onNext={nextStep} />;
      case 1:
        return (
          <StepPersonalInfo
            formData={formData}
            onUpdate={updateFormData}
            onNext={nextStep}
            onBack={prevStep}
          />
        );
      case 2:
        return (
          <StepContactInfo
            formData={formData}
            onUpdate={updateFormData}
            onNext={nextStep}
            onBack={prevStep}
          />
        );
      case 3:
        return (
          <StepPhoto
            formData={formData}
            onUpdate={updateFormData}
            onNext={nextStep}
            onBack={prevStep}
          />
        );
      case 4:
        return (
          <StepDocuments
            formData={formData}
            onUpdateDocuments={updateDocuments}
            onSetDocumentValidated={setDocumentValidated}
            onNext={nextStep}
            onBack={prevStep}
          />
        );
      case 5:
        return (
          <StepConfirmation
            formData={formData}
            onBack={prevStep}
            onSubmitSuccess={handleSubmitSuccess}
            isSubmitting={isSubmitting}
            setIsSubmitting={setIsSubmitting}
            setError={setError}
            error={error}
          />
        );
      default:
        return <StepWelcome onNext={nextStep} />;
    }
  };

  const isWelcome = currentStep === 0;

  return (
    <div className="onboarding-page">
      <div className={isWelcome ? 'onboarding-container onboarding-container--wide' : 'onboarding-container'}>
        <div className="onboarding-header">
          <img
            src="/logo_jama_unido_color.png"
            alt="JAMA Delivery"
            className="onboarding-logo"
          />
        </div>

        {!isWelcome && <Stepper currentStep={currentStep} />}

        <div className={isWelcome ? 'onboarding-content onboarding-content--wide' : 'onboarding-content'}>
          {renderStep()}
        </div>

        <div className="onboarding-footer">
          <p>¿Necesitas ayuda? Contáctanos:</p>
          <a href="mailto:soporte@jamaec.com">soporte@jamaec.com</a>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="bg-decoration">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>
    </div>
  );
};

export default DriverOnboarding;
